import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList2 from '../../component/Account/AccountList2';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import musicTitle from '../../asset/music/luckyMe.mp3'


const SeoEunHye = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "원효종❤️서은혜 결혼합니다.";
    const openDesc = "2025년 06월 15일 일요일 오후 12시\n천안 비렌티웨딩홀 본관3층 베르테홀";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/206/thumb.jpg";

    const lng = 127.159091407247;
    const lat = 36.8478668706719;

    const placeTelNum = "041-554-5500";

    const forShuttleBus = "1) 천안종합터미널 - 신세계백화점(아라리오광장) \n    - 올리브영&스타벅스 건물 앞 횡단보도 승차\n2) 두정역 1번 출구에서 나와서 오른쪽으로 50m지점 \n    파란색 셔틀버스 승강장 승차\n\n* 천안종합터미널 → 두정역 → 비렌티웨딩홀 순서\n* 예식시간 1시간 전부터 30분 간격으로 셔틀버스 \n    이용 가능";
    const forBus = "1) 성환방면 100번대 버스 이용 후 천안공주대학교에서 \n    하차 후 도보 5분\n2) 천안역(이태리안경)정류장에서 100번, 110번 승차\n3) 천안고속버스터미널(맥도날드 앞) 정류장에서 112번, \n    140번, 141번, 143번, 144번, 145번, 150번, 151번 \n    승차"
    const forCar = "네비게이션에 '비렌티웨딩홀' 또는 '천안대로1198-30' \n입력";


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "우리 결혼합니다.";

    const msg1 = "초록빛 싱그러운 여름날,\n특별한 것을 하지 않아도\n함께하면 행복한 사람과\n서로의 모든 계절을 함께 하려고 합니다.";
    const msg2 = "부부로서 첫걸음을 시작하는 뜻 깊은 날,\n늘 곁에서 아껴주시는 고마운 분들을 모십니다.";


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "원효종",
            bank: "우리은행",
            accountNumber : "1002-160-237270",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FdmMbhiDf"
        }
        ,{
            role: "신랑 부",
            name: "원상희",
            bank: "농협은행",
            accountNumber : "352-2225-6620-43",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "이경숙",
            bank: "농협은행",
            accountNumber : "735078-52-061909",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "서은혜",
            bank: "기업은행",
            accountNumber : "925-004660-01-012",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej85yzGY0"
        }
        ,{
            role: "신부 부",
            name: "서호석",
            bank: "신한은행",
            accountNumber : "110-015-526355",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "이명희",
            bank: "농협은행",
            accountNumber : "473-12-328013",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "서로의 첫 인상은 어땠어?",
            groomAnswer: "나랑닮았네!",
            brideAnswer: "나랑닮았네?"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "드림컴트루★",
            brideAnswer: "세상든든해"
        },
        {
            question : "유부남/녀 기념으로 각오 한 마디!",
            groomAnswer: "곁에있을게",
            brideAnswer: "매일예쁠게"
        },
        {
            question : "우리가 꿈꾸는 가정은?",
            groomAnswer: "딸둘아들둘",
            brideAnswer: "웃음넘치는"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "고맙습니다♥︎",
            brideAnswer: "많이많이요♥︎"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김영광",
            call: "010-6244-8978"
        }
        ,{
            role: "신랑 부",
            name: "김유겸",
            call: "010-9856-7702"
        }
        ,{
            role: "신랑 모",
            name: "유성림",
            call: "010-6380-7706"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "김다예",
            call: "010-2055-8891"
        }
        ,{
            role: "신부 부",
            name: "김성환",
            call: "010-6393-1917"
        }
        ,{
            role: "신부 모",
            name: "박수정",
            call: "010-3711-1922"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#505D89"} letteringFontColor={"#505D89"} dateColor={"#8f9cc7"} bottom={"25%"} bottom2={"15.5%"} dateBottom={"1%"} top={"1%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList2 conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forShuttleBus={forShuttleBus} forCar={forCar} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default SeoEunHye;